// extracted by mini-css-extract-plugin
module.exports = {"root":"Game_root__1Oq3k","noWordsContainer":"Game_noWordsContainer__2dIbN"};